import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { REQUEST_ERROR_CODE } from '../../const/code';
import { BUSINESS_ERROR_MESSAGE_KEYS, ErrorType } from './const';
/**
 * 应用错误
 * 通用的应用层错误
 */ export class AppError extends Error {
    constructor(type, message, status){
        super(message || type), _define_property(this, "type", void 0), _define_property(this, "status", void 0);
        this.type = type;
        this.status = status;
    }
}
/**
 * 检查错误是否为网络错误
 * @param error - 需要检查的错误对象
 * @returns 如果是网络错误返回 true，否则返回 false
 */ export function isNetworkError(error) {
    // TypeError 通常是网络连接问题
    if (error instanceof TypeError) {
        return true;
    }
    const errorMessage = error instanceof Error ? error.message.toLowerCase() : String(error).toLowerCase();
    const networkErrorPatterns = [
        'network',
        'fetch',
        'load failed',
        'aborted',
        'connection',
        'timeout',
        'bodystreambuffer'
    ];
    return networkErrorPatterns.some((pattern)=>errorMessage.includes(pattern));
}
/**
 * 判断 ErrorType 是否为网络错误类型
 * @param errorType - ErrorType 枚举值
 * @returns 如果是任何网络错误类型返回 true，否则返回 false
 */ export function isNetworkErrorType(errorType) {
    return errorType === ErrorType.NETWORK_ERROR || errorType === ErrorType.NETWORK_ERROR_CHAT_FETCH || errorType === ErrorType.NETWORK_ERROR_CHAT_STREAM || errorType === ErrorType.NETWORK_ERROR_RESUME_FETCH || errorType === ErrorType.NETWORK_ERROR_RESUME_STREAM;
}
export function isCreditError(error) {
    var _errorLike_data, _errorLike_response_data, _errorLike_response;
    if (error instanceof AppError && error.type === ErrorType.CREDIT_ERROR) {
        return true;
    }
    const errorLike = error;
    return (errorLike === null || errorLike === void 0 ? void 0 : errorLike.code) === REQUEST_ERROR_CODE.CREDIT_ERROR || (errorLike === null || errorLike === void 0 ? void 0 : (_errorLike_data = errorLike.data) === null || _errorLike_data === void 0 ? void 0 : _errorLike_data.code) === REQUEST_ERROR_CODE.CREDIT_ERROR || (errorLike === null || errorLike === void 0 ? void 0 : (_errorLike_response = errorLike.response) === null || _errorLike_response === void 0 ? void 0 : (_errorLike_response_data = _errorLike_response.data) === null || _errorLike_response_data === void 0 ? void 0 : _errorLike_response_data.code) === REQUEST_ERROR_CODE.CREDIT_ERROR;
}
export function getBusinessErrorMessage(code) {
    const normalizedCode = Number(code);
    const messageKey = Number.isFinite(normalizedCode) ? BUSINESS_ERROR_MESSAGE_KEYS[normalizedCode] : undefined;
    return intl.get(messageKey ?? 'error.boundary.title');
}
